export default __webpack_public_path__ + "static/media/7.2aa4eb57.png";